import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { TARGET_LABELS } from "../lib/constants";
import { Hourglass, Eye, EyeOff, Calculator, ChevronRight } from "lucide-react";

const eur = (v) => (v ? Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }) : null);
const dd = (v) => (v ? new Date(v).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit" }) : null);

function Row({ onClick, testid, title, sub, right, badge }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid} className="w-full flex items-center justify-between gap-3 px-5 py-3 hover:bg-secondary/50 transition-colors text-left">
      <div className="min-w-0">
        <div className="font-medium text-sm truncate flex items-center gap-2">{title}{badge}</div>
        <div className="text-xs text-muted-foreground truncate">{sub}</div>
      </div>
      <div className="flex items-center gap-3 shrink-0">{right}<ChevronRight className="h-4 w-4 text-muted-foreground" /></div>
    </button>
  );
}

const Days = ({ n }) => (n == null ? null : <span className={`text-xs font-semibold ${n > 14 ? "text-red-400" : n > 7 ? "text-primary" : "text-muted-foreground"}`}>{n} gg</span>);

// Preventivi in attesa di risposta: lead in fase Preventivo + preventivi "Aperto" del Preventivatore.
export default function PreventiviAttesa() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/preventivi-attesa").then((r) => setD(r.data)).catch(() => setD({ leads: [], preventivi: [] })); }, []);
  const leads = d?.leads || [], prevs = d?.preventivi || [];
  return (
    <Card className="rounded border-border" data-testid="preventivi-attesa">
      <div className="p-5 border-b border-border">
        <h2 className="text-sm uppercase tracking-[0.15em] text-muted-foreground font-bold flex items-center gap-2"><Hourglass className="h-4 w-4 text-primary" />Preventivi in attesa di risposta</h2>
        <p className="text-[11px] text-muted-foreground mt-1">Lead in fase Preventivo (esclusi Free e Rete) e preventivi aperti del Preventivatore. In alto i più vecchi.</p>
      </div>
      <div className="px-5 pt-4 pb-1 text-xs uppercase tracking-widest font-bold text-muted-foreground">Lead in fase Preventivo · {leads.length}</div>
      <div className="divide-y divide-border" data-testid="pa-leads">
        {d && leads.length === 0 && <p className="px-5 py-4 text-sm text-muted-foreground">Nessun lead in attesa.</p>}
        {leads.map((l) => (
          <Row key={l.id} onClick={() => navigate(`/leads/${l.id}`)} testid={`pa-lead-${l.id}`} title={l.name}
            badge={l.opened_count ? <span className="text-[10px] text-emerald-400 flex items-center gap-0.5" title={`Aperto ${l.opened_count} volte`}><Eye className="h-3 w-3" />{l.opened_count}</span>
              : l.sent_at ? <span className="text-[10px] text-muted-foreground flex items-center gap-0.5" title="Non ancora aperto"><EyeOff className="h-3 w-3" />non aperto</span> : null}
            sub={[TARGET_LABELS[l.target], l.city, l.assigned_to_name, l.kwp ? `${l.kwp} kWp` : null, eur(l.prezzo), l.sent_at ? `inviato ${dd(l.sent_at)}` : "non inviato"].filter(Boolean).join(" · ")}
            right={<Days n={l.days} />} />
        ))}
      </div>
      <div className="px-5 pt-5 pb-1 text-xs uppercase tracking-widest font-bold text-muted-foreground flex items-center gap-1.5 border-t border-border mt-2"><Calculator className="h-3.5 w-3.5" />Preventivatore · aperti · {prevs.length}</div>
      <div className="divide-y divide-border pb-2" data-testid="pa-preventivi">
        {d && prevs.length === 0 && <p className="px-5 py-4 text-sm text-muted-foreground">Nessun preventivo aperto.</p>}
        {prevs.map((p) => (
          <Row key={p.id} onClick={() => navigate(`/preventivatore?open=${p.id}`)} testid={`pa-prev-${p.id}`} title={`${p.numero || ""} ${p.cliente}`.trim()}
            sub={[p.citta, p.consulente, p.potenza ? `${p.potenza} kWp` : null, eur(p.totale), dd(p.data)].filter(Boolean).join(" · ")}
            right={<Days n={p.days} />} />
        ))}
      </div>
    </Card>
  );
}
